<script>
  /* global Global */
  export let value;
  export let short = false;
  export let lang = undefined;

  const projectStyle = Global.project.style;
</script>

<a href={value.link} class='important-link' class:important-link-short={short} class:important-link-box-old={projectStyle === 'old' || projectStyle === 'sharp'}>
  <div class='important-link-box'
    class:important-link-box-red={value.color === 'red'}
    class:important-link-box-yellow={value.color === 'yellow'}
    class:important-link-box-green={value.color === 'green'}
    class:important-link-box-blue={value.color === 'blue'}
    class:important-link-box-purple={value.color === 'purple'}>

    <div class='important-link-box-label'>
      <div class='important-link-box-label-text'> <span class='material-icons'> {value.icon} </span> {value.label[lang]} </div>
    </div>
  </div>
</a>

<style>
  .important-link {
    flex-grow: 1;

    width: 100%;

    text-decoration: none;

    color: inherit;
  }

  .important-link-box {
    padding: 15px;

    border-radius: var(--radius-lg);

    color: var(--white);

    transition: box-shadow 1s ease-in-out, transform 1s ease-in-out;
  }

  .important-link-short .important-link-box {
    padding: 10px;
  }

  .important-link-box:hover {
    box-shadow: 0px 0px 10px 0px var(--grey-5);

    transform: scale(1.025);
  }

  .important-link-box-label {
    display: flex;
    justify-content: center;
    align-items: center;

    width: 100%;
    height: 20px;

    font-weight: 550;
  }

  .important-link-box-label-text {
    text-align: center;
  }

  .important-link-box-red {
    background: linear-gradient(135deg, var(--red), var(--dark-red));
  }

  .important-link-box-old .important-link-box-red {
    background: var(--red);
  }

  .important-link-box-yellow {
    background: linear-gradient(135deg, var(--yellow), var(--orange));
  }

  .important-link-box-old .important-link-box-yellow {
    background: var(--yellow);
  }

  .important-link-box-green {
    background: linear-gradient(135deg, var(--green), var(--dark-green));
  }

  .important-link-box-old .important-link-box-green {
    background: var(--green);
  }

  .important-link-box-blue {
    background: linear-gradient(135deg, var(--blue), var(--dark-blue));
  }

  .important-link-box-old .important-link-box-blue {
    background: var(--blue);
  }

  .important-link-box-purple {
    background: linear-gradient(135deg, var(--purple), var(--turquoise));
  }

  .important-link-box-old .important-link-box-purple {
    background: var(--purple);
  }

  :global(body.dark) .important-link-box {
    color: var(--grey-3);
  }

  :global(body.dark) .important-link-box:hover {
    box-shadow: 0px 0px 10px 0px var(--grey-9);
  }

  :global(body.dark) .important-link-box-red {
    background: linear-gradient(135deg, var(--red-dark), var(--dark-red-dark));
  }

  :global(body.dark) .important-link-box-old .important-link-box-red {
    background: var(--red-dark);
  }

  :global(body.dark) .important-link-box-yellow {
    background: linear-gradient(135deg, var(--yellow-dark), var(--orange-dark));
  }

  :global(body.dark) .important-link-box-old .important-link-box-yellow {
    background: var(--yellow-dark);
  }

  :global(body.dark) .important-link-box-green {
    background: linear-gradient(135deg, var(--green-dark), var(--dark-green-dark));
  }

  :global(body.dark) .important-link-box-old .important-link-box-green {
    background: var(--green-dark);
  }

  :global(body.dark) .important-link-box-blue {
    background: linear-gradient(135deg, var(--blue-dark), var(--dark-blue-dark));
  }

  :global(body.dark) .important-link-box-old .important-link-box-blue {
    background: var(--blue-dark);
  }

  :global(body.dark) .important-link-box-purple {
    background: linear-gradient(135deg, var(--purple-dark), var(--turquoise-dark));
  }

  :global(body.dark) .important-link-box-old .important-link-box-purple {
    background: var(--purple-dark);
  }

  @media only screen and (max-width: 1300px) {
    .important-link {
      width: calc((100% - 20px) / 2);
    }
  }

  @media only screen and (max-width: 750px) {
    .important-link {
      width: 100%;
    }
  }
</style>
